<script>
  import { onMount } from 'svelte';

  import TrackCard from '$lib/client/shared/track-card.svelte';
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import Button, { Icon, Label } from '@smui/button';
  import { Circle } from 'svelte-loading-spinners';
  import { quintOut, cubicOut } from 'svelte/easing';
  import { mediaTransition, mediaAnimation } from '$lib/client/utils/media';
  import { DateTime } from 'luxon';
  import { straightFlip } from '$lib/client/animations/straight-flip';
  import { flip } from 'svelte/animate';
  import { fly } from 'svelte/transition';
  import { open, mobile, currentChannel } from '$lib/store.js';
  import { playlist } from '$lib/playlist-store.js';
  import { schedule } from '$lib/schedule-store.js';

  function relativeTime(i) {
    if (i === 2) {
      return 'current';
    } else if (i < 2) {
      return 'past';
    } else {
      return 'future';
    }
  }

  $: scheduleUrl = [
    '/music',
    $currentChannel?.slug,
    'schedules',
    DateTime.now().toFormat('yyyy/MM/dd')
  ]
    .filter((x) => x)
    .join('/');

  onMount(() => {
    schedule.init($currentChannel);
  });
</script>

<div class="schedule-container">
  <div class="t-center">
    <Button
      on:click={() => {
        $open = !$open;
      }}
    >
      <Icon class="material-icons" title="Hide Schedule">schedule</Icon>

      {#if $open}
        <Label>Hide Schedule</Label>
      {:else}
        <Label>Open Schedule</Label>
      {/if}
    </Button>

    <Button tag="a" href={scheduleUrl}
      ><Icon class="material-icons">calendar_today</Icon> <Label>Full Schedule</Label></Button
    >
  </div>

  {#if $open}
    {#if $schedule?.tracks?.length}
      {#each [$schedule] as schedule (schedule.channel.key)}
        <div class="schedule">
          {#each schedule.tracks as track, index ([$currentChannel.key, track.scheduled_at, track.id].join('-'))}
            {@const relative_time = relativeTime(index)}
            <div
              class={relative_time}
              transition:mediaTransition={[
                                         {
                                           query: '(max-width: 480px)',
                                           transition: fly,
                                           options: {
                                             duration: 300,
                                             easing: quintOut,
                                             x: 400
                                           }
                                         },
                                         {
                                           query: '(min-width: 481px)',
                                           transition: fly,
                                           options: {
                                             duration: 500,
                                             easing: quintOut,
                                             x: -200
                                           }
                                         }
                                         ]}
              animate:mediaAnimation={[
                                     {
                                       query: '(max-width: 480px)',
                                       animation: straightFlip,
                                       options: {
                                         duration: 300,
                                         y: 50,
                                         opacity: 1
                                       }
                                     },

                                     {
                                       query: '(min-width: 481px)',
                                       animation: flip,
                                       options: {
                                         delay: 250,
                                         duration: 500,
                                         easing: quintOut
                                       }
                                     }
                                     ]}
            >
              <span class="timing mdc-typography--caption">
                {#if relative_time === 'current'}
                  On now
                {:else if relative_time === 'past'}
                  {DateTime.fromMillis(track.scheduled_at).toRelative()}
                {:else}
                  {DateTime.fromMillis(track.scheduled_at).toLocaleString(DateTime.TIME_24_SIMPLE)}
                {/if}
              </span>
              <TrackCard
                {track}
                showRating={relative_time === 'current' || relative_time === 'past'}
                imageType={$mobile && relative_time !== 'current' ? 'thumbnail' : 'card'}
              />
            </div>
          {/each}
        </div>
      {/each}
    {:else}
      <div class="spinner u-p-huge">
        <Circle duration="2s" size="36" color="#00CCFE" />
      </div>
    {/if}
  {/if}
</div>
